import { RefreshCw } from "lucide-react";
import { Button } from "./ui/button";
import { useTaal } from "@/contexts/TaalContext";

/** Fix 4: na een weigering haalt deze knop een verse kaart met een nieuw token.
 *  Het is de ENIGE weg naar een nieuw token na een weigering; zie `lib/kaartToken.js`. */
export default function OpenOpnieuw({ onClick, bezig }) {
  const { t } = useTaal();
  return (
    <Button size="sm" variant="outline" className="min-h-11 px-4" disabled={bezig}
            onClick={onClick} data-testid="kaart-open-opnieuw">
      <RefreshCw className="h-3 w-3 mr-1" />
      {t("Open opnieuw")}
    </Button>
  );
}
